var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandConsistency(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 64 64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff7058"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.38 42.5-5.54 21.5-3.77-9.74-7.72 6.7 5.9-23.77c.82.26 1.62.56 2.24 1.02 1.74 1.27 2.68 4.21 4.77 4.89 1.25.4 2.69-.14 4.12-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.99 40.14-.18.7c-1.57.49-3.16 1.17-4.53.73-2.09-.68-3.04-3.62-4.77-4.89-.54-.4-1.2-.66-1.9-.89l.18-.73z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.34 40.88-.33-1.29 11.2-4.53.18.73c-.7.23-1.36.5-1.9.89-1.74 1.27-2.68 4.21-4.76 4.89-1.33.43-2.86-.21-4.39-.69z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.65 60.96-7.72-6.7-3.76 9.74-5.41-21.46c1.39.46 2.77.94 3.98.56 2.08-.68 3.03-3.62 4.76-4.89.63-.46 1.42-.75 2.24-1.02z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m53.77 20.85c0 2.23-2.5 4.04-3.16 6.05-.68 2.09.26 5.01-1 6.75-1.28 1.75-4.36 1.76-6.11 3.03-1.74 1.26-2.69 4.2-4.77 4.88-2.01.65-4.5-1.14-6.73-1.14s-4.72 1.8-6.73 1.14c-2.09-.68-3.04-3.62-4.77-4.88-1.75-1.28-4.84-1.28-6.11-3.03-1.26-1.74-.32-4.66-1-6.75-.65-2.01-3.16-3.82-3.16-6.05s2.5-4.04 3.16-6.05c.68-2.09-.26-5.01 1-6.75 1.28-1.75 4.36-1.76 6.11-3.03 1.74-1.26 2.69-4.2 4.77-4.88 2.01-.65 4.5 1.14 6.73 1.14s4.72-1.8 6.73-1.14c2.09.68 3.04 3.62 4.77 4.88 1.75 1.28 4.84 1.28 6.11 3.03 1.26 1.74.32 4.66 1 6.75.66 2.02 3.16 3.82 3.16 6.05z",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.74 37.19c-.82.26-1.62.56-2.24 1.02-1.74 1.27-2.68 4.21-4.76 4.89-1.21.39-2.59-.1-3.98-.56l-.42-1.66c1.53.48 3.07 1.12 4.4.69 2.08-.68 3.03-3.62 4.76-4.89.54-.4 1.2-.66 1.9-.89z",
    fill: "#f0543f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.81 40.84-.43 1.66c-1.43.47-2.86 1.01-4.1.6-2.09-.68-3.04-3.62-4.77-4.89-.63-.46-1.42-.75-2.24-1.02l.35-1.4c.7.23 1.36.5 1.9.89 1.74 1.27 2.68 4.21 4.77 4.89 1.36.44 2.94-.24 4.52-.73z",
    fill: "#f0543f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20.85,
    fill: "#f8b64c",
    r: 13.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 12.34 2.77 5.6 6.19.9-4.48 4.37 1.06 6.16-5.54-2.91-5.54 2.91 1.06-6.16-4.48-4.37 6.19-.9z",
    fill: "#f4f4f4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandConsistency);
export default __webpack_public_path__ + "static/media/brand-consistency.9ebb9beed2ea46a76fee808e6908e21a.svg";
export { ForwardRef as ReactComponent };